// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__15eoh","buttons":"Password_buttons__avW1C"};